import React from 'react'

import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const Icon60Link1 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 48 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M45.003,17.464 L40.465,22.003 C38.533,23.935 35.964,24.999 33.230,24.999 L31.000,24.999 C30.448,24.999 30.000,24.552 30.000,24.000 C30.000,23.447 30.448,23.000 31.000,23.000 L33.230,23.000 C35.430,23.000 37.497,22.143 39.050,20.589 L43.589,16.050 C45.143,14.496 46.000,12.429 46.000,10.231 C46.000,8.032 45.143,5.965 43.589,4.411 C42.034,2.856 39.967,2.000 37.769,2.000 C35.571,2.000 33.504,2.856 31.949,4.411 L27.411,8.949 C25.856,10.504 25.000,12.571 25.000,14.769 L25.000,17.000 C25.000,17.552 24.552,18.000 24.000,18.000 C23.448,18.000 23.000,17.552 23.000,17.000 L23.000,14.769 C23.000,12.036 24.064,9.468 25.997,7.535 L30.535,2.997 C32.467,1.064 35.036,-0.001 37.769,-0.001 C40.502,-0.001 43.071,1.064 45.003,2.997 C46.935,4.929 48.000,7.498 48.000,10.231 C48.000,12.964 46.935,15.533 45.003,17.464 ZM16.000,33.000 C15.744,33.000 15.488,32.902 15.293,32.707 C14.902,32.316 14.902,31.683 15.293,31.293 L32.293,14.292 C32.684,13.902 33.316,13.902 33.707,14.292 C34.097,14.683 34.097,15.316 33.707,15.706 L16.707,32.707 C16.512,32.902 16.256,33.000 16.000,33.000 ZM17.000,24.999 L14.768,24.999 C12.570,24.999 10.503,25.856 8.950,27.410 L4.411,31.949 C2.856,33.503 2.000,35.571 2.000,37.769 C2.000,39.967 2.856,42.034 4.411,43.588 C5.966,45.143 8.033,45.999 10.231,45.999 C12.429,45.999 14.496,45.143 16.051,43.588 L20.589,39.050 C22.143,37.495 23.000,35.429 23.000,33.230 L23.000,31.000 C23.000,30.447 23.448,30.000 24.000,30.000 C24.552,30.000 25.000,30.447 25.000,31.000 L25.000,33.230 C25.000,35.962 23.935,38.532 22.003,40.464 L17.465,45.002 C15.533,46.935 12.964,47.999 10.231,47.999 C7.498,47.999 4.929,46.935 2.997,45.002 C1.064,43.071 -0.000,40.502 -0.000,37.769 C-0.000,35.036 1.064,32.467 2.997,30.534 L7.535,25.996 C9.467,24.065 12.036,23.000 14.768,23.000 L17.000,23.000 C17.552,23.000 18.000,23.447 18.000,24.000 C18.000,24.552 17.552,24.999 17.000,24.999 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

Icon60Link1.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
